/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {UnsubscribeRequest, UnsubscribeResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Public one-click unsubscribe endpoint. Verifies the HMAC token, then flips the user's
newsletter status to OPTED_OUT. Always returns 200 — failure modes (bad token,
missing user) are reported in the response body so email-client URL pre-fetchers
don't trigger 4xx noise and users get a friendly page either way.
 */
export type unsubscribeResponse200 = {
  data: UnsubscribeResponse
  status: 200
}

export type unsubscribeResponseSuccess = unsubscribeResponse200 & {
  headers: Headers
}
export type unsubscribeResponse = unsubscribeResponseSuccess

export const getUnsubscribeUrl = () => {
  return `/newsletter/unsubscribe`
}

export const unsubscribe = async (
  unsubscribeRequest: UnsubscribeRequest,
  options?: RequestInit,
): Promise<unsubscribeResponse> => {
  return customFetch<unsubscribeResponse>(getUnsubscribeUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(unsubscribeRequest),
  })
}
